import React from "react";

const StatCard = ({ about, count, status, icon, colorCode }) => {
    return (
        <div style={{ backgroundColor: `var(--card-bg-${colorCode})` }} className="flex h-[100%] min-h-[140px] sm:min-h-0 rounded-lg items-center shadow-md p-4">
            <div className="flex flex-col w-[70%]">
                <p className="text-[3vw] sm:text-[0.8vw]">{about}</p>
                <p className="text-[10vw] sm:text-[2vw] font-semibold">{count}</p>
                <p className="text-[3vw] sm:text-[0.8vw]">{status}</p>
            </div>
            <div className="flex h-[10vw] sm:h-[2.5vw] aspect-[1/1] bg-white ml-auto rounded-md items-center justify-center">
                <img src={icon} alt="logo" className="h-[60%]" />
            </div>
        </div>
    )
}

export default StatCard;